import { FundBasketDashboard } from "@funds/pages/fund-basket-dashboard";
import { createFileRoute } from "@tanstack/react-router";
import { fundBasketsQueryOptions } from "creso-core/hooks";

export const Route = createFileRoute("/(auth)/_headed/funds/_layout/basket")({
  component: FundBasketDashboard,
  loader: async ({ context }) => {
    const { queryClient } = context;
    await queryClient.prefetchQuery(
      fundBasketsQueryOptions({
        strategy: [],
        tenure: [],
      })
    );
  },
});
